import { Loader2, RotateCw } from 'lucide-react'

/** 기간 바에 두는 '조회' 버튼. 현재 기간·필터 그대로 최신 목록을 재조회.
 *  (더존 출고처리의 조회 버튼과 동일 — 날짜는 그대로, 다른 사람 실시간 입력 반영) */
export function RefreshButton({ onClick, busy }: { onClick: () => void; busy?: boolean }) {
  return (
    <button type="button" onClick={onClick} disabled={busy}
            title="현재 기간·필터 그대로 최신 목록을 다시 불러옵니다 (다른 사람이 입력한 내용 반영)"
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold
                       bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-60
                       disabled:cursor-not-allowed shrink-0">
      {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <RotateCw className="w-4 h-4" />}
      {busy ? '조회중…' : '조회'}
    </button>
  )
}
